import React, { createContext, PropsWithChildren, useCallback, useEffect, useState } from "react";

import 'dayjs/locale/fr';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.locale('fr');

const userSettingsStorageKey = 'user_settings';

const UserSettingsContextState = createContext<Record<string, any>>({agency_id: null, user: null});
const UserSettingsContextDispatch = createContext<((key: string, value: any) => void) | null>(null);

const UserSettingsProvider = ({children}: PropsWithChildren) => {
    const [userSettingsState, setUserSettingsState] = useState<{agency_id: Number | null, user: string | null}>({agency_id: null, user: null});

    const setUserSetting = useCallback((key: string, value: any) => {
        const userSettings : Record<string, any> = {...userSettingsState};
        const updateduserSetting = {[key]: value.toString()};
        localStorage.setItem(userSettingsStorageKey, JSON.stringify({...userSettings, ...updateduserSetting}));
        setUserSettingsState(userSettings => ({
            ...userSettings,
            ...updateduserSetting
        }));
    }, [userSettingsState]);

    useEffect(() => {
        const userSettings = JSON.parse(localStorage.getItem(userSettingsStorageKey) || '{}');
        if (userSettings) setUserSettingsState(userSettings);
    }, []);


    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='fr' dateLibInstance={dayjs.utc}>
            <UserSettingsContextDispatch.Provider value={setUserSetting}>
                <UserSettingsContextState.Provider value={userSettingsState}>
                    {children}
                </UserSettingsContextState.Provider>
            </UserSettingsContextDispatch.Provider>
        </LocalizationProvider>
    );
};

export { UserSettingsProvider, UserSettingsContextState, UserSettingsContextDispatch, userSettingsStorageKey };